import { render, staticRenderFns } from "./history_modal.vue?vue&type=template&id=569c4529&"
import script from "./history_modal.vue?vue&type=script&lang=js&"
export * from "./history_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports